import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/polski';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-58" data-mp="e3didugelir3">
      <div className="mx-auto max-w-6xl" data-id="element-59" data-mp="9mhfagqn76z">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-60" data-mp="58z5fyjcikb5">
          <div className="lg:col-span-7" data-id="element-61" data-mp="574jcgwc8m5h">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-62" data-mp="3mguiw1ojetxq">Co zmienia POLSKI GOTOWY™</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-63" data-mp="3rgp880snzbgo">
              Od chaosu w planowaniu do <em className="text-red-700" data-id="element-64" data-mp="3diqxr6hgrz6g">spokoju i pewności.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-65" data-mp="3ig0t12rjb527">
            Wyobraź sobie, że zaczynasz tydzień z lekcjami już zaplanowanymi. Wiesz, co robić z każdą
            klasą – i masz pod ręką lekcje minuta po minucie, karty do lektur, ćwiczenia z kluczem,
            wzory wypracowań i sprawdziany.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-66" data-mp="1fad9l4x4akbg">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-67" data-mp="1sznlym1qr8ej" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-68" data-mp="10bjatl0ei34g">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-69" data-mp="wb7qk9bya4ti">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-70" data-mp="1aba6vr4m0q6n">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-71" data-mp="15bnsvfgyj5ws">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-72" data-mp="2lpnt6rjpsxkk">Bez POLSKI GOTOWY™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-73" data-mp="2lrgwbwv4cznt">
              Czy to brzmi znajomo?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-74" data-mp="2oqh3wmckh5ti">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-75" data-mp="2sr10not8a7f4">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-76" data-mp="2xpue5h8ilyfa" />
                  <span data-id="element-77" data-mp="32oxl57822epw">
                    <span className="block font-semibold text-slate-900/80" data-id="element-78" data-mp="253jgofg7gdmp">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-79" data-mp="2f1peakuzaxlr">
            <p className="text-sm font-semibold text-red-300" data-id="element-80" data-mp="2jsfkg0b8b4hi">Z POLSKI GOTOWY™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-81" data-mp="1md1nyavdhi1c">
              Mniej planowania. Więcej uczenia.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-82" data-mp="1raa9mlfqc47c">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-83" data-mp="1jrkjqdciv1yf">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-84" data-mp="1er6a4qv9vjya">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-85" data-mp="14v39jpg2jtdg" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-86" data-mp="w318pq238b2n">
          Skup się na uczniach – a nie na tworzeniu wszystkich materiałów od zera.
        </p>
      </div>
    </section>;
}